import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconListIndented16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconListIndented16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2 2.5v11a.5.5 0 0 0 1 0v-11a.5.5 0 0 0-1 0m12 1a.5.5 0 0 1-.5.5H5.474a.5.5 0 0 1 0-1H13.5a.5.5 0 0 1 .5.5m-1.852 3a.5.5 0 0 1-.5.5H5.475a.5.5 0 1 1 0-1h6.173a.5.5 0 0 1 .5.5M13.5 10a.5.5 0 1 0 0-1H5.476a.5.5 0 0 0 0 1zm-1.351 2.5a.5.5 0 0 1-.5.5H5.475a.5.5 0 0 1 0-1h6.173a.5.5 0 0 1 .5.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconListIndented16);
